export default "__VITE_ASSET__e159429c__"